import { Layout, Row, Col } from 'antd';
import { getParticipantes, eliminarParticipante, enviarEmail } from '../api/participantesApi';
import React, { useState, useEffect } from 'react';
import { Table, Spin, Alert, Space, Button, message, Popconfirm, Input, Tag, Tooltip  } from 'antd';
import { EditOutlined, DeleteOutlined, SearchOutlined, MailOutlined, PlusOutlined } from '@ant-design/icons';
import { DownloadOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import ExcelJS from 'exceljs';

const { Content } = Layout;

function Participantes() {
  const navigate = useNavigate();
  const [participantes, setParticipantes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [enviandoEmails, setEnviandoEmails] = useState([]);
  const [exportandoExcel, setExportandoExcel] = useState(false);
  const [filtrosTabla, setFiltrosTabla] = useState({});
  const [ordenTabla, setOrdenTabla] = useState({});

  const handleEdit = (record) => {
    console.log("Editar:", record.id);
    navigate(`/usuarios/editar/${record.id}`);
  };

  const generarPDF = () => {
  // Inicializa el documento en horizontal (landscape)
  const doc = new jsPDF('landscape'); 
  
  // Título del PDF
  doc.text("Reporte de Corredores", 14, 15);

  // 1. Definimos los encabezados (Omitimos "Acciones" y reducimos algunos largos)
  const columnasPDF = [
    "Folio", "No.", "Nombre", "Nacimiento", "Edad", 
    "Categoría", "Sexo", "Teléfono", "Pago", "Registro"
  ];

  // 2. Diccionario de categorías (el mismo que usas en tu tabla)
  const nombresCategorias = {
    "Juvenil": "Juvenil (19 años o menos)",
    "Libre": "Libre (20-39 años)",
    "Master": "Máster (40-49 años)",
    "Veteranos": "Veteranos (50-59 años)",
    "Veteranosplus": "Veteranos Plus (60 en adelante)",
    "MEDICOVeteranosfemenil": "Médicos Femenil (Hasta 44 años)",
    "MEDICOVeteranosvaronil": "Médicos Varonil (Hasta 49 años)",
    "MEDICOVeteranosvaronilplus": "Médicos Varonil (50 años en adelante)",
    "MEDICOVeteranosfemenilplus": "Médicos Femenil (45 años en adelante)"
  };

  // 3. Transformamos los datos de React/AntD a texto plano para el PDF
  const filasPDF = filteredData.map((record, index) => {
    return [
      record.folio || "Pendiente",
      index + 1, // Número de corredor
      record.nombre || "",
      record.nacimiento || "",
      record.edad || "",
      nombresCategorias[record.categoria] || record.categoria || "",
      record.sexo || "",
      record.telefono || "",
      // Simplificamos el estado de pago para que sea texto y no un componente Tag
      record.transaction_status === "approved" || record.pagado ? "Aprobado" : "Pendiente", 
      // Asegúrate de que formatearFecha devuelva un string
      record.fecha_creacion ? formatearFecha(record.fecha_creacion) : "" 
    ];
  });

  autoTable(doc, {
    head: [columnasPDF],
    body: filasPDF,
    startY: 20, 
    styles: { fontSize: 8 }, 
    headStyles: { fillColor: [41, 128, 185] } 
  });

  doc.save("lista_corredores.pdf");
};


  const handleDelete = async (record) => {
    try {
      await eliminarParticipante(record.id);
      message.success("Registro eliminado correctamente");
      obtenerUsuarios();
    } catch (error) {
      message.error("Error al eliminar el registro");
      console.error(error);
    }
  };
  const sendEmail = async (record) => {
    setEnviandoEmails((prev) => [...prev, record.id]);
    try {
      const resultado = await enviarEmail(record.id);
      if (resultado?.success !== true) {
        message.error(resultado?.message || "Error al enviar email", 6);
        return;
      }
      message.success(resultado.message || "Correo enviado correctamente.");
      setParticipantes((prev) => prev.map((participante) =>
        participante.id === record.id ? { ...participante, enviado: 1 } : participante
      ));
    } catch (error) {
      message.error(
        error.response?.data?.message || "No se pudo conectar con el servidor para enviar el correo.",
        6
      );
      console.error(error);
    } finally {
      setEnviandoEmails((prev) => prev.filter((id) => id !== record.id));
    }
  };
  const obtenerUsuarios = async () => {
  try {
    setLoading(true);

    const data = await getParticipantes();

    if (data.success) {
      console.log(data.data)
      setParticipantes(data.data);
      // setTotal(data.total);
    } else {
      setError(data.message || "Error desconocido");
    }

  } catch (err) {
    setError(err.message || "Fallo al conectar con el servidor");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    obtenerUsuarios();
  }, []);

  if (loading) return <Spin tip="Cargando participantes..." size="large" />;
  if (error) return <Alert message="Error" description={error} type="error" showIcon />;

  const renderEstadoPago = (estado, pagado) => {
  if (Number(pagado) === 1 || estado === "approved") {
    return <Tag color="green">Aprobado</Tag>;
  }

  switch (estado) {
    case "pending":
    case "in_process":
      return <Tag color="gold">Pendiente</Tag>;

    case "rejected":
      return <Tag color="red">Rechazado</Tag>;

    case "cancelled":
    case "cancelled_by_collector":
      return <Tag color="default">Cancelado</Tag>;

    case "refunded":
      return <Tag color="blue">Reembolsado</Tag>;

    case "charged_back":
      return <Tag color="volcano">Contracargo</Tag>;

    default:
      return <Tag>Sin estado</Tag>;
  }
};

const formatearFecha = (fecha) => {
  if (!fecha) {
    return "-";
  }

  const parsed = new Date(fecha);

  if (Number.isNaN(parsed.getTime())) {
    return fecha;
  }

  return parsed.toLocaleString("es-MX", {
    dateStyle: "short",
    timeStyle: "short"
  });
};

  const columns = [
  {
    title: "Folio",
    dataIndex: "folio",
    key: "folio",
    fixed: "left",
    width: 140,
    render: (folio) => folio || <Tag color="gold">Pendiente</Tag>
  },
  {
    title: "Nombre",
    dataIndex: "nombre",
    key: "nombre",
    width: 220,
    sorter: (a, b) =>
      (a.nombre || "").localeCompare(b.nombre || "")
  },
  {
    title: "Número de Corredor",
    dataIndex: "numero", 
    key: "numero",
    width: 90,
  },
  {
    title: "Nacimiento",
    dataIndex: "nacimiento",
    key: "nacimiento",
    width: 115
  },
  {
    title: "Edad",
    dataIndex: "edad",
    key: "edad",
    width: 75,
    sorter: (a, b) => Number(a.edad) - Number(b.edad)
  },
  {
    title: "Categoría",
    dataIndex: "categoria",
    key: "categoria",
    width: 220, // Aumenté el ancho para que quepa el texto de las edades
    filters: [
      { text: "Juvenil (19 años o menos)", value: "Juvenil" },
      { text: "Libre (20-39 años)", value: "Libre" },
      { text: "Máster (40-49 años)", value: "Master" }, // Corregido: "Master" sin acento
      { text: "Veteranos (50-59 años)", value: "Veteranos" },
      { text: "Veteranos Plus (60 en adelante)", value: "Veteranosplus" },
      { text: "Médicos Femenil (Hasta 44 años)", value: "MEDICOVeteranosfemenil" },
      { text: "Médicos Varonil (Hasta 49 años)", value: "MEDICOVeteranosvaronil" },
      { text: "Médicos Varonil (50 años en adelante)", value: "MEDICOVeteranosvaronilplus" },
      { text: "Médicos Femenil (45 años en adelante)", value: "MEDICOVeteranosfemenilplus" },
    ],
    onFilter: (value, record) => record.categoria === value,
    render: (categoria) => {
      // Diccionario que empareja exactamente lo que hay en la BD con el texto a mostrar
      const nombresCategorias = {
        "Juvenil": "Juvenil (19 años o menos)",
        "Libre": "Libre (20-39 años)",
        "Master": "Máster (40-49 años)", // Corregido: Llave sin acento
        "Veteranos": "Veteranos (50-59 años)",
        "Veteranosplus": "Veteranos Plus (60 en adelante)",
        "MEDICOVeteranosfemenil": "Médicos Femenil (Hasta 44 años)",
        "MEDICOVeteranosvaronil": "Médicos Varonil (Hasta 49 años)",
        "MEDICOVeteranosvaronilplus": "Médicos Varonil (50 años en adelante)",
        "MEDICOVeteranosfemenilplus": "Médicos Femenil (45 años en adelante)"
      };
      
      return nombresCategorias[categoria] || categoria;
    }
  },
  {
    title: "Sexo",
    dataIndex: "sexo",
    key: "sexo",
    width: 90
  },
  {
    title: "Talla playera",
    dataIndex: "talla",
    key: "talla",
    width: 90,
    render: (talla) => talla || "-"
  },
  {
    title: "Correo",
    dataIndex: "email",
    key: "email",
    width: 240,
    ellipsis: true,
    render: (email) => (
      <Tooltip title={email}>
        <span>{email || "-"}</span>
      </Tooltip>
    )
  },
  {
    title: "Teléfono",
    dataIndex: "telefono",
    key: "telefono",
    width: 120
  },
  {
    title: "Estado del pago",
    key: "transaction_status",
    width: 135,
    filters: [
      { text: "Aprobado", value: "approved" },
      { text: "Pendiente", value: "pending" },
      { text: "En proceso", value: "in_process" },
      { text: "Rechazado", value: "rejected" },
      { text: "Cancelado", value: "cancelled" }
    ],
    onFilter: (value, record) =>
      record.transaction_status === value,
    render: (_, record) =>
      renderEstadoPago(
        record.transaction_status,
        record.pagado
      )
  },
  {
    title: "Método de pago",
    dataIndex: "tipopago",
    key: "tipopago",
    width: 130,
    render: (metodo) => metodo || "-"
  },
  {
    title: "ID de pago",
    dataIndex: "paymentid",
    key: "paymentid",
    width: 160,
    ellipsis: true,
    render: (paymentId) => (
      <Tooltip title={paymentId}>
        <span>{paymentId || "-"}</span>
      </Tooltip>
    )
  },
  {
    title: "Correo enviado",
    dataIndex: "enviado",
    key: "enviado",
    width: 120,
    filters: [
      { text: "Sí", value: "1" },
      { text: "No", value: "0" }
    ],
    onFilter: (value, record) =>
      String(Number(record.enviado || 0)) === value,
    render: (enviado) =>
      Number(enviado) === 1
        ? <Tag color="green">Sí</Tag>
        : <Tag color="red">No</Tag>
  },
  {
    title: "Fecha de registro",
    dataIndex: "fecha_creacion",
    key: "fecha_creacion",
    width: 160,
    render: formatearFecha
  },
  {
    title: "Acciones",
    key: "acciones",
    fixed: "right",
    width: 420,
    render: (_, record) => (
      <Space>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() => handleEdit(record)}
        >
          Editar
        </Button>
        <Button
          icon={<MailOutlined />}
          onClick={() => sendEmail(record)}
          loading={enviandoEmails.includes(record.id)}
          disabled={!record.email}
        >
          Enviar email
        </Button>
        <Popconfirm
          title="¿Seguro que deseas eliminar?"
          onConfirm={() => handleDelete(record)}
          okText="Sí"
          cancelText="No"
        >
          <Button danger icon={<DeleteOutlined />}>
            Eliminar
          </Button>
        </Popconfirm>
      </Space>
    )
  }
];

  const filteredData = participantes.filter((item) =>
    item.nombre?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.email?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.numero?.toString().includes(searchText) ||
    item.telefono?.toString().includes(searchText)
  );

  const generarExcel = async () => {
    setExportandoExcel(true);
    try {
      const datos = filteredData.filter((record) => columns.every((column) => {
        const valores = filtrosTabla[column.key];
        return !valores?.length || !column.onFilter ||
          valores.some((value) => column.onFilter(value, record));
      }));
      const columnaOrden = columns.find((column) => column.key === ordenTabla.columnKey);
      if (ordenTabla.order && columnaOrden?.sorter) {
        datos.sort((a, b) => columnaOrden.sorter(a, b) *
          (ordenTabla.order === 'ascend' ? 1 : -1));
      }

      const estadosPago = {
        approved: 'Aprobado', pending: 'Pendiente', in_process: 'Pendiente',
        rejected: 'Rechazado', cancelled: 'Cancelado',
        cancelled_by_collector: 'Cancelado', refunded: 'Reembolsado',
        charged_back: 'Contracargo'
      };
      const categorias = columns.find((column) => column.key === 'categoria').filters;
      const workbook = new ExcelJS.Workbook();
      const hoja = workbook.addWorksheet('Participantes');
      hoja.columns = columns.filter((column) => column.key !== 'acciones').map((column) => ({
        header: column.title,
        key: column.key,
        width: Math.max(15, Math.round(column.width / 7))
      }));
      datos.forEach((record) => hoja.addRow({
        folio: record.folio || 'Pendiente',
        nombre: record.nombre ?? '',
        numero: record.numero ?? '',
        nacimiento: record.nacimiento ?? '',
        edad: record.edad ?? '',
        categoria: categorias.find((categoria) => categoria.value === record.categoria)?.text || record.categoria || '',
        sexo: record.sexo ?? '',
        talla: record.talla ?? '',
        email: record.email ?? '',
        telefono: record.telefono == null ? '' : String(record.telefono),
        transaction_status: Number(record.pagado) === 1 || record.transaction_status === 'approved'
          ? 'Aprobado' : estadosPago[record.transaction_status] || 'Sin estado',
        payment_method: record.payment_method ?? '',
        paymentid: record.paymentid == null ? '' : String(record.paymentid),
        date_paid: formatearFecha(record.date_paid),
        enviado: Number(record.enviado) === 1 ? 'Sí' : 'No',
        fecha_creacion: formatearFecha(record.fecha_creacion)
      }));
      hoja.getRow(1).font = { bold: true };
      hoja.views = [{ state: 'frozen', ySplit: 1 }];
      hoja.autoFilter = { from: 'A1', to: 'P1' };

      const buffer = await workbook.xlsx.writeBuffer();
      const url = URL.createObjectURL(new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }));
      const enlace = document.createElement('a');
      enlace.href = url;
      enlace.download = 'lista_participantes.xlsx';
      document.body.appendChild(enlace);
      enlace.click();
      enlace.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      console.error(err);
      message.error('Error al exportar a Excel');
    } finally {
      setExportandoExcel(false);
    }
  };

  return (
      <Layout style={{ minHeight: '100vh' }}>
      <Content style={{ padding: '24px', background: '#f0f2f5' }}>
      <h1>Listado de Participantes</h1>
      <Row style={{ marginBottom: 16 }}>
        <Col span={4}>
          <Input
            prefix={<SearchOutlined />}
            placeholder="Buscar participante..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
        <Space style={{ marginBottom: 16 }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/agregar')}
          >
            Agregar participante
          </Button>
          <Button 
            type="primary" 
            icon={<DownloadOutlined />} 
            onClick={generarPDF}
            style={{ backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' }} // Opcional: rojo estilo PDF
          >
            Exportar a PDF
          </Button>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={generarExcel}
            loading={exportandoExcel}
            style={{ backgroundColor: '#217346', borderColor: '#217346' }}
          >
            Exportar a Excel
          </Button>
        </Space>
          <Table
            dataSource={filteredData}
            columns={columns}
            rowKey="id"
            onChange={(_, filters, sorter) => {
              setFiltrosTabla(filters);
              setOrdenTabla(sorter);
            }}
            scroll={{ x: true }}
          />
        </Col>
      </Row>
    </Content>
  </Layout>
  );
}
export default Participantes;
